// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/font-awesome/css/font-awesome.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("img/select.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clearfix:before,
.clearfix:after {
  display: table;
  content: " ";
}
.clearfix:after {
  clear: both;
}
.pull-right {
  float: right !important;
}
.pull-left {
  float: left !important;
}
.hide {
  display: none !important;
}
.show {
  display: block !important;
}
.invisible {
  visibility: hidden;
}
.hidden {
  display: none !important;
}
.affix {
  position: fixed;
}
@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
}
@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
}
@-moz-keyframes fadeOut {
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes fadeOut {
  100% {
    opacity: 0;
  }
}
@-o-keyframes fadeOut {
  100% {
    opacity: 0;
  }
}
@keyframes fadeOut {
  100% {
    opacity: 0;
  }
}
@-moz-keyframes slideLeft {
  0% {
    transform: translate(100%, 0);
  }
}
@-webkit-keyframes slideLeft {
  0% {
    transform: translate(100%, 0);
  }
}
@-o-keyframes slideLeft {
  0% {
    transform: translate(100%, 0);
  }
}
@keyframes slideLeft {
  0% {
    transform: translate(100%, 0);
  }
}
@-moz-keyframes slideLeftOut {
  100% {
    transform: translate(100%, 0);
  }
}
@-webkit-keyframes slideLeftOut {
  100% {
    transform: translate(100%, 0);
  }
}
@-o-keyframes slideLeftOut {
  100% {
    transform: translate(100%, 0);
  }
}
@keyframes slideLeftOut {
  100% {
    transform: translate(100%, 0);
  }
}
@-moz-keyframes slideRight {
  0% {
    transform: translate(-100%, 0);
  }
}
@-webkit-keyframes slideRight {
  0% {
    transform: translate(-100%, 0);
  }
}
@-o-keyframes slideRight {
  0% {
    transform: translate(-100%, 0);
  }
}
@keyframes slideRight {
  0% {
    transform: translate(-100%, 0);
  }
}
@-moz-keyframes slideRightOut {
  100% {
    transform: translate(-100%, 0);
  }
}
@-webkit-keyframes slideRightOut {
  100% {
    transform: translate(-100%, 0);
  }
}
@-o-keyframes slideRightOut {
  100% {
    transform: translate(-100%, 0);
  }
}
@keyframes slideRightOut {
  100% {
    transform: translate(-100%, 0);
  }
}
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  padding: 0;
  background-color: #eee;
  padding: 20px;
}
@media (min-width: 768px) {
  body {
    padding: 30px;
  }
}
body,
button,
input,
textarea,
select {
  font-family: Poppins, Arial, sans-serif;
  font-size: 15px;
}
a {
  color: #000;
  text-decoration: none;
  transition: 0.2s ease;
}
p {
  margin: 0 0 20px;
  padding: 0;
}
ol {
  padding-left: 16px;
}
h1 {
  padding: 0;
  margin: 0 0 20px;
  font-size: 2.25em;
  line-height: 1.1;
}
@media (min-width: 480px) {
  h1 {
    font-size: 3em;
  }
}
@media (min-width: 768px) {
  h1 {
    font-size: 4em;
  }
}
@media (min-width: 1024px) {
  h1 {
    font-size: 4.4em;
  }
}
h2 {
  padding: 0;
  margin: 0 0 20px;
  font-size: 1.5em;
  line-height: 1;
}
@media (min-width: 480px) {
  h2 {
    font-size: 2em;
  }
}
@media (min-width: 768px) {
  h2 {
    font-size: 3em;
  }
}
@media (min-width: 1024px) {
  h2 {
    font-size: 3.5em;
  }
}
h3 {
  padding: 0;
  margin: 0 0 20px;
  font-size: 1.2em;
  line-height: 1;
}
@media (min-width: 480px) {
  h3 {
    font-size: 1.5em;
  }
}
@media (min-width: 768px) {
  h3 {
    font-size: 2em;
  }
}
ul {
  padding-left: 20px;
}
ul li {
  margin-bottom: 5px;
}
ul li:last-child {
  margin-bottom: 0px;
}
img {
  width: 100%;
  height: auto;
  display: block;
  margin: 0;
  padding: 0;
}
hr {
  border-top: 1px solid #000;
  margin: 30px 0;
}
video {
  display: block;
  width: 100%;
}
audio {
  display: inline-block;
  vertical-align: middle;
}
button {
  user-select: none;
}
.fa {
  display: inline-block;
  vertical-align: middle;
}
.h--400,
.text--400 {
  font-weight: 400;
}
.text--center {
  text-align: center;
}
.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
}
@media (min-width: 768px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1024px) {
  .grid.grid--3 {
    grid-template-columns: repeat(3, 1fr);
  }
  .grid.grid--catalog {
    grid-template-columns: repeat(3, minmax(300px, 1fr));
  }
}
.flex {
  display: flex;
  flex-wrap: wrap;
  margin: -15px;
}
.flex.flex--auto {
  flex-wrap: nowrap;
}
.flex>div {
  display: block;
  box-sizing: border-box;
  padding: 15px;
  width: 100%;
}
@media (min-width: 768px) {
  .flex .flex__20 {
    width: 20%;
  }
  .flex .flex__25 {
    width: 25%;
  }
  .flex .flex__30 {
    width: 30%;
  }
  .flex .flex__33 {
    width: 33.33%;
  }
  .flex .flex__35 {
    width: 35%;
  }
  .flex .flex__40 {
    width: 40%;
  }
  .flex .flex__45 {
    width: 45%;
  }
  .flex .flex__50 {
    width: 50%;
  }
  .flex .flex__55 {
    width: 55%;
  }
  .flex .flex__60 {
    width: 60%;
  }
  .flex .flex__65 {
    width: 65%;
  }
  .flex .flex__66 {
    width: 66.66%;
  }
  .flex .flex__70 {
    width: 70%;
  }
  .flex .flex__75 {
    width: 75%;
  }
  .flex .flex__80 {
    width: 80%;
  }
}
label {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
input,
select {
  vertical-align: middle;
  line-height: 20px;
}
input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  background-color: transparent;
  border: 2px solid rgba(0,0,0,0.25);
  border-radius: 3px;
  cursor: pointer;
}
input[type="checkbox"]:checked {
  background-color: #000;
  border-color: #000;
}
input[type="checkbox"]:checked::after {
  content: "";
  display: block;
  width: 6px;
  height: 10px;
  border: 2px solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin: 0 3px;
}
input[type='text'] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 10px 15px;
  border: 2px solid #000;
}
select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 10px 15px;
  border: 2px solid #000;
  min-width: 120px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) right center no-repeat;
  background-size: 30px;
}
input[type="range"] {
  -webkit-appearance: none;
  background: rgba(0,0,0,0.2);
  height: 4px;
  border-radius: 20px;
}
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background: #000;
  border-radius: 50%;
  cursor: pointer;
}
input[type="range"]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: #000;
  border-radius: 50%;
  cursor: pointer;
}
input[type="range"]::-ms-thumb {
  width: 20px;
  height: 20px;
  background: #000;
  border-radius: 50%;
  cursor: pointer;
}
.btn {
  display: inline-block;
  user-select: none;
  background: transparent;
  color: #000;
  padding: 10px 20px;
  border: 2px solid #000;
  -webkit-appearance: none;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.85em;
  cursor: pointer;
  border-radius: 30px;
  transition: 0.2s ease;
  vertical-align: middle;
  line-height: 20px;
}
@media (min-width: 768px) {
  .btn {
    font-size: 0.95em;
    letter-spacing: 1px;
  }
}
.btn:hover {
  background: #000;
  color: #fff;
}
.btn:hover svg path {
  fill: #fff;
}
.btn svg {
  display: inline-block;
  max-height: 16px;
  max-width: 16px;
  vertical-align: -4px;
  margin: 0 5px 0 0;
}
.btn.btn--black {
  background: #000;
  color: #fff;
}
.btn.btn--block {
  display: block;
  width: 100%;
  margin: 0;
}
.btn.btn--link {
  border: 0;
}
.btn.btn--md {
  padding: 12px 25px;
}
header {
  margin-bottom: 20px;
  padding: 0;
}
@media (min-width: 768px) {
  header {
    background: #fff;
    margin-bottom: 30px;
    padding: 20px;
  }
}
header .header__logo {
  font-weight: bold;
  color: #000;
  text-decoration: none;
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  padding: 0;
}
header .header__logo img {
  width: auto;
  height: 60px;
}
@media (min-width: 768px) {
  header .header__logo img {
    height: 70px;
  }
}
header .header__logo.header__logo--tecnologiasdelagua {
  font-size: 120%;
  padding: 20px;
}
@media (max-width: 768px) {
  header .header__logo.header__logo--tecnologiasdelagua {
    padding: 10px 0;
  }
}
header .header__logo.header__logo--facultad {
  margin-left: 20px;
}
@media (max-width: 1600px) {
  header .header__logo.header__logo--facultad {
    display: none;
  }
}
header .header__right {
  display: none;
}
@media (min-width: 1060px) {
  header .header__right {
    display: block;
    float: right;
  }
}
header .header__search {
  width: 100%;
  position: relative;
  display: inline-block;
  margin: 15px 0;
  width: 300px;
}
header .header__search input {
  border-radius: 30px;
  padding-right: 40px;
  padding-left: 20px;
  width: 100%;
  background-color: transparent;
}
header .header__search button {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
}
header .header__bread {
  opacity: 0.4;
}
header .header__nav {
  display: inline-block;
  vertical-align: middle;
  margin-right: 20px;
}
@media (max-width: 768px) {
  header .header__nav {
    display: none;
  }
}
header .header__nav ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
header .header__nav ul li {
  position: relative;
  display: inline-block;
  margin: 0;
}
header .header__nav ul li a {
  font-size: 16px;
  color: #000;
  text-decoration: none;
  display: block;
  padding: 5px 5px;
  border-bottom: 2px solid transparent;
}
header .header__nav ul li a .fa {
  margin-top: -2px;
}
header .header__nav ul li:hover>a {
  border-color: #000;
}
header .header__nav ul li:hover ul {
  display: block;
}
header .header__nav ul li ul {
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 320px;
  display: none;
  animation: fadeIn 0.5s ease;
  z-index: 2;
}
@media (max-width: 480px) {
  header .header__nav ul li ul {
    width: calc(100vh -20);
  }
}
header .header__nav ul li ul li {
  margin-top: -2px;
}
header .header__nav ul li ul li a {
  background: #fff;
  border: 2px solid #000;
  padding: 10px 15px;
}
header .header__nav ul li ul li a:hover {
  background: #000;
  color: #fff;
}
header .header__hamburger {
  float: right;
  padding: 10px 5px;
  margin-top: 5px;
  display: block;
  cursor: pointer;
}
@media (min-width: 768px) {
  header .header__hamburger {
    display: none;
  }
}
header .header__hamburger div {
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
}
header .header__hamburger div div {
  width: 30px;
  height: 2px;
  background: #000;
  margin: 3px 0;
  display: block;
}
header .header__menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: none;
  overflow: hidden;
}
header .header__menu._open {
  display: block;
}
header .header__menu._closing .header__menu__ {
  animation: slideLeftOut 0.5s ease both;
}
@media (min-width: 768px) {
  header .header__menu {
    display: none;
  }
}
header .header__menu .header__menu__ {
  background: #fff;
  position: relative;
  height: 100%;
  overflow: auto;
  animation: slideLeft 0.5s ease;
  padding: 25px;
}
header .header__menu .header__menu__close {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 15px 20px;
  cursor: pointer;
}
header .header__menu .header__menu__items {
  margin-bottom: 20px;
}
header .header__menu .header__menu__items ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
header .header__menu .header__menu__items ul li {
  padding: 0;
  margin: 0;
}
header .header__menu .header__menu__items ul li a {
  display: block;
  border: 2px solid #000;
  padding: 10px 15px;
  margin-top: -2px;
}
header .header__menu .header__menu__search {
  margin-bottom: 20px;
}
header .header__menu .header__menu__logos {
  text-align: center;
}
header .header__menu .header__menu__logos .header__logo {
  display: inline-block;
  padding: 15px 10px;
  vertical-align: middle;
}
header .header__menu .header__menu__logos .header__logo img {
  height: auto;
  max-width: 160px;
  max-height: 80px;
  width: 100%;
}
#body {
  display: none;
}
#body.body--loaded {
  display: block !important;
  animation: fadeIn 0.5s ease;
}
footer {
  margin: 30px -20px -20px;
  background: #fff;
  padding: 30px;
  font-size: 0.85em;
  text-align: center;
}
@media (min-width: 768px) {
  footer {
    margin: 30px 0 0;
    font-size: 0.9em;
  }
}
footer a {
  display: block;
  margin: 5px 0;
}
@media (min-width: 768px) {
  footer a {
    display: inline-block;
    margin: 0 6px;
  }
}
footer span {
  display: none;
}
@media (min-width: 768px) {
  footer span {
    display: inline-block;
  }
}
footer .footer__logos {
  margin-bottom: 30px;
}
footer .footer__logos .footer__logo {
  margin: 20px;
  display: inline-block;
  vertical-align: middle;
}
footer .footer__logos .footer__logo img {
  width: auto;
  max-width: 180px;
  margin: 0 auto;
}
footer .footer__logos .footer__logo.footer__logo--depto img {
  max-height: 90px;
}
footer .footer__credit {
  max-width: 800px;
  margin: 0 auto 20px;
}
footer .footer__links a {
  border-bottom: 1px solid #000;
}
section {
  margin-bottom: 30px;
}
section:last-child {
  margin-bottom: 0;
}
section .section__breadcrumb {
  font-weight: 600;
  margin-bottom: 10px;
}
@media (max-width: 480px) {
  section .section__breadcrumb {
    font-size: 0.85em;
    margin-bottom: 5px;
  }
}
section .section__breadcrumb a {
  display: inline-block;
  border-bottom: 2px solid #000;
}
@media (max-width: 480px) {
  section .section__breadcrumb a:first-child {
    display: block;
    border-bottom: 0;
  }
}
section .section__breadcrumb .fa {
  margin: 0 5px 2px;
  font-size: 0.7em;
}
@media (max-width: 480px) {
  section .section__breadcrumb .fa {
    margin-left: 0;
  }
}
section .section__breadcrumb span {
  opacity: 0.4;
}
section .section__breadcrumb a {
  opacity: 0.4;
  border-color: transparent;
}
section .section__breadcrumb a:hover {
  opacity: 1;
  border-color: #000;
}
@media (max-width: 480px) {
  section .section__breadcrumb {
    margin-top: -5px;
  }
  section .section__breadcrumb a:first-child,
  section .section__breadcrumb span {
    display: none;
  }
}
section.section--white {
  background: #fff;
  padding: 30px;
}
@media (min-width: 480px) {
  section.section--white {
    padding: 30px;
  }
}
@media (min-width: 768px) {
  section.section--white {
    padding: 40px;
  }
}
section.section--main {
  margin-bottom: 30px;
  position: relative;
}
@media (max-width: 480px) {
  section.section--main {
    margin: 0 -10px;
  }
}
section.section--main .section__intro {
  margin-bottom: 20px;
}
@media (min-width: 768px) {
  section.section--main .section__intro {
    margin-bottom: 30px;
    display: grid;
    grid-gap: 40px;
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 768px) {
  section.section--main .section__intro .section__header {
    margin-bottom: 20px;
  }
}
section.section--main .section__intro .section__header .section__title {
  position: relative;
}
@media (min-width: 768px) {
  section.section--main .section__intro .section__header .section__title {
    font-size: 5vw;
  }
}
@media (max-width: 768px) {
  section.section--main .section__intro .section__header .section__title {
    margin-bottom: 15px;
  }
}
section.section--main .section__intro .section__header .section__excerpt {
  font-size: 1.1em;
  margin-bottom: 0;
}
@media (min-width: 1024px) {
  section.section--main .section__intro .section__header .section__excerpt {
    font-size: 1.75vw;
  }
}
section.section--main .section__intro .section__header .section__excerpt p {
  margin: 0;
}
section.section--main .section__intro .section__3d {
  height: 200px;
  margin: 0 -30px 20px;
  margin: 0 0 20px;
  border: 2px solid #000;
  position: relative;
/*
                @media (min-width: \$desktop)
                    top 40px
                    right 40px
                */
}
@media (min-width: 768px) {
  section.section--main .section__intro .section__3d {
    width: 100%;
    padding-bottom: 90%;
    height: 0;
    margin: 0;
  }
}
section.section--main .section__intro .section__3d canvas {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  cursor: move;
}
section.section--main .section__content {
  position: relative;
  column-gap: 40px;
}
section.section--main .section__content p:first-child {
  font-size: 140%;
}
@media (min-width: 768px) {
  section.section--main .section__content {
    column-count: 2;
  }
}
section.section--main .section__articles {
  margin-top: 30px;
}
@media (max-width: 480px) {
  section.section--category {
    margin: 0 -10px;
  }
}
section.section--category .section__category__content {
  margin-bottom: 30px;
}
@media (min-width: 768px) {
  section.section--category .section__category__content {
    column-count: 2;
    column-gap: 20px;
  }
}
@media (min-width: 1440px) {
  section.section--category .section__category__content {
    column-count: 3;
    column-gap: 30px;
  }
}
section.section--category .section__category__content p {
  margin-bottom: 8px;
}
section.section--category .section__category__content p:last-child {
  marign-bottom: 0;
}
section.section--category .section__category__content p:first-child {
  font-size: 1.25em;
}
@media (min-width: 768px) {
  section.section--category .section__category__content p:first-child {
    font-size: 1.4em;
  }
}
section.section--search .section__search {
  margin-bottom: 30px;
  padding: 20px 30px;
  background: #fff;
}
@media (max-width: 480px) {
  section.section--instrument {
    margin: 0 -20px;
    padding: 25px;
  }
}
section.section--instrument .section__details {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  margin: 10px 0 30px;
}
@media (max-width: 768px) {
  section.section--instrument .section__details {
    gap: 20px;
  }
}
@media (max-width: 480px) {
  section.section--instrument .section__details {
    gap: 15px;
  }
}
section.section--instrument .section__details .section__detail {
  border-top: 1px solid #000;
  padding-top: 20px;
  margin: 0;
  flex: 1;
  box-sizing: border-box;
  min-width: 300px;
}
@media (max-width: 480px) {
  section.section--instrument .section__details .section__detail {
    padding-top: 15px;
  }
}
@media (min-width: 768px) {
  section.section--instrument .section__details .section__detail {
    min-width: 320px;
  }
}
section.section--instrument .section__details .section__detail strong {
  display: block;
  opacity: 0.4;
  font-weight: normal;
  line-height: 1;
  margin-bottom: 4px;
  font-size: 0.9em;
}
section.section--instrument .section__details .section__detail .large-text {
  display: block;
  font-weight: normal;
  color: #333;
  font-size: 1.1em;
}
@media (min-width: 480px) {
  section.section--instrument .section__details .section__detail .large-text {
    font-size: 1.2em;
  }
}
section.section--instrument .section__details .section__detail.section__detail--dimensions {
  display: flex;
  gap: 20px;
}
section.section--instrument .section__details .section__detail.section__detail--dimensions p {
  margin: 0;
}
section.section--instrument .section__swiper {
  margin: 0 -25px;
}
@media (min-width: 480px) {
  section.section--instrument .section__swiper {
    margin: 0 -30px;
  }
}
@media (min-width: 768px) {
  section.section--instrument .section__swiper {
    margin: 0;
  }
}
section.section--instrument .section__3d {
  background: #e9e9e9;
  margin: 0 -25px;
}
@media (min-width: 480px) {
  section.section--instrument .section__3d {
    margin: 0;
  }
}
section.section--instrument .section__3d .section__header {
  padding: 30px 30px 0;
}
section.section--instrument .section__3d .section__title {
  margin: 0;
}
section.section--instrument .section__3d p {
  margin: 0;
}
section.section--instrument .section__canvas {
  position: relative;
  padding-bottom: 100%;
  height: 400px;
  cursor: grab;
}
@media (min-width: 1024px) {
  section.section--instrument .section__canvas {
    height: auto;
    padding-bottom: 66.66666666666667%;
  }
}
section.section--instrument .section__canvas canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  background-color: #e9e9e9;
}
section.section--instrument .section__canvas .section__canvas__tools {
  position: absolute;
  bottom: 20px;
  left: 0px;
  width: 100%;
  text-align: center;
}
@media (max-width: 768px) {
  section.section--instrument .section__canvas .section__canvas__tools .section__canvas__zoom input {
    width: 140px;
  }
}
section.section--instrument .section__canvas label {
  padding: 5px;
  display: inline-block;
}
section.section--instrument .section__canvas label input {
  vertical-align: middle;
}
section.section--instrument .section__canvas label input[type='range'] {
  width: 260px;
}
section.section--instrument .section__canvas.section__canvas-B {
  position: relative;
  padding-bottom: 50%;
}
section.section--instrument .section__ar {
  background-color: #e9e9e9;
  padding: 30px;
}
@media (min-width: 1024px) {
  section.section--instrument .section__ar {
    display: none;
  }
}
section.section--instrument .section__info {
  position: relative;
  padding: 30px;
  background-color: #e9e9e9;
}
section.section--instrument .section__info h2,
section.section--instrument .section__info h3,
section.section--instrument .section__info h4 {
  margin-top: 0;
}
section.section--instrument .section__info h3 {
  font-size: 1.2em;
}
section.section--instrument .section__info a {
  text-decoration: underline;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  inline-size: 150px;
}
@media (min-width: 768px) {
  section.section--instrument .section__info.section__info--lg {
    padding: 50px;
  }
}
@media (min-width: 768px) {
  section.section--instrument .section__info .large-textXXX {
    font-size: 1.2em;
  }
}
section.section--instrument .section__microtomografia h2 {
  margin-bottom: 0;
}
article.article--category {
  background: #fff;
  padding: 50px 0;
  overflow: hidden;
  position: relative;
  border-top: 2px solid #000;
/*@media (min-width: \$tablet)
        display grid
        grid-gap 30px
        grid-template-columns 460px 1fr
    */
}
@media (min-width: 1024px) {
  article.article--category {
    padding: 40px 0;
  }
}
article.article--category .article__title {
  margin-bottom: 15px;
  font-size: 240%;
}
article.article--category .article__description {
  max-width: 600px;
}
@media (min-width: 768px) {
  article.article--category .article__btnXX {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
}
article.article--category .article__images {
  margin: 20px 0;
}
article.article--category .article__images .gggg {
  display: flex;
  flex-wrap: wrap;
  margin: -2px;
}
article.article--category .article__images .gggg .flex__33 {
  width: 33%;
  padding: 2px;
}
article.article--instrument {
  position: relative;
  background: rgba(255,255,0,0) 0;
  cursor: pointer;
  border: 1px solid #000;
}
article.article--instrument .article__image {
  position: relative;
}
article.article--instrument .article__body {
  padding: 20px;
  border-top: 1px solid #000;
  transition: 0.25s ease;
}
article.article--instrument .article__num {
  padding-top: 5px;
  margin: 0;
  opacity: 0.4;
}
article.article--instrument .article__link {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 20px;
  color: #000;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: bold;
  opacity: 0.4;
  transition: 0.2s ease;
}
article.article--instrument:hover .article__link {
  opacity: 1;
}
article.article--instrument .article__title {
  margin: 0;
  padding: 0;
  font-size: 1.2em;
  line-height: 1.2;
}
article.article--instrument .article__title a {
  color: #000;
  text-decoration: none;
}
article.article--instrument .article__title a::after {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
article.article--instrument .article__title a span {
  font-weight: normal;
}
article.article--instrument .article__canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.25s 0.25s ease backwards;
}
article.article--instrument .article__canvas canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
}
article.article--instrument:hover .article__canvas {
  display: block;
}
.swiper.swiper--main {
  position: relative;
  user-select: none;
  overflow: hidden;
}
.swiper-thumbnails {
  display: flex;
  gap: 5px;
  margin: 5px 0 0;
}
.swiper-thumbnails .swiper-thumbnail {
  cursor: pointer;
  opacity: 0.6;
  transition: 0.2s ease;
  position: relative;
}
.swiper-thumbnails .swiper-thumbnail.--current {
  opacity: 1;
  z-index: 2;
}
.swiper-thumbnails .swiper-thumbnail.--current::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid #000;
  box-sizing: border-box;
}
.swiper-thumbnails .swiper-thumbnail:hover {
  opacity: 1;
}
.swiper-thumbnails.swiper-thumbnails--B {
  display: flex;
  gap: 0;
  margin: 0;
  flex-wrap: wrap;
}
.swiper-thumbnails.swiper-thumbnails--B .swiper-thumbnail {
  width: 33.33%;
  box-sizing: border-box;
}
.swiper-button-next,
.swiper-button-prev {
  color: #000 !important;
  opacity: 0.2;
  transition: 0.2s ease;
}
.swiper-button-next:hover,
.swiper-button-prev:hover {
  opacity: 1;
}
.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #000;
}
.micView {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.25);
  z-index: 20;
  display: none;
  animation: fadeIn 0.5s ease;
  text-align: center;
}
.micView .micView__container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 30px;
  box-sizing: border-box;
  overflow: auto;
}
@media (min-width: 768px) {
  .micView .micView__container {
    transform: translate(0, -50%);
    max-width: 400px;
    margin-left: -200px;
    top: 50%;
    left: 50%;
    height: auto;
  }
}
.micView .micView__close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 20px;
  cursor: pointer;
  opacity: 0.25;
  transition: 0.2s ease;
}
.micView .micView__close:hover {
  opacity: 1;
}
.micView .micView__bigButton {
  background: #fff;
  color: #000;
  border: 2px solid #000;
  cursor: pointer;
  width: 120px;
  height: 120px;
  border-radius: 120px;
  padding: 0;
  margin: 0;
  text-transform: uppercase;
  transition: 0.2s ease;
  font-weight: bold;
  position: relative;
  tap: 0;
}
.micView .micView__bigButton::after {
  content: "";
  display: block;
  width: 120%;
  height: 120%;
  position: absolute;
  top: -10%;
  left: -10%;
  box-sizing: border-box;
  border: 2px solid #000;
  border-radius: 120px;
  animation: animPulse 0.5s ease infinite;
  opacity: 0;
  transition: 0.2s ease;
}
.micView .micView__bigButton.active::after {
  opacity: 1;
}
.micView .micView__bigButton:active {
  transform: scale(0.95);
}
.micView .micView__bigButton:hover {
  background: #000;
  color: #fff;
}
.micView .micView__text {
  margin: 20px 0;
}
.micView .micView__level {
  margin: 20px 0;
  border: 2px solid #000;
  padding: 20px;
  border-radius: 30px;
}
.micView .micView__level .micView__level__icon {
  width: 20px;
  float: left;
  margin-top: -8px;
  margin-left: -5px;
}
.micView .micView__level .micView__level__bar {
  margin-left: 30px;
  background: #000;
  height: 3px;
  border-radius: 4px;
  transition: 0.05s;
}
.micView .micView__gain {
  margin: 20px 0;
}
.micView .micView__fall {
  padding: 20px;
  background: #eee;
  padding-top: 20px;
  margin-top: 20px;
  font-size: 0.95em;
}
.micView .micView__fall h4 {
  margin-bottom: 0;
}
.micView .micView__fall p {
  margin-bottom: 5px;
}
.micView .micView__fall .micView__fall__toggle {
  cursor: pointer;
}
.micView .micView__fall .micView__fall__options {
  display: none;
}
#micView__anim {
  display: block;
  max-width: 240px;
  margin: 20px auto;
}
#micView__anim .bar {
  fill: none;
  stroke: #231f20;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 4px;
  opacity: 0.1;
  transform-origin: 50% 90%;
  transition: 0.1s ease all;
}
#micView__anim .bar.active {
  animation: animOsc 0.15s linear infinite;
/*
            &:nth-child(1)
                animation-delay .01s
            &:nth-child(2)
                animation-delay .021s
            &:nth-child(4)
                animation-delay .032s
            &:nth-child(4)
                animation-delay .043s
            &:nth-child(5)
                animation-delay .055s
            &:nth-child(6)
                animation-delay .07s
            &:nth-child(7)
                animation-delay .09s
            &:nth-child(8)
                animation-delay .11s
            &:nth-child(9)
                animation-delay .15s
            &:nth-child(10)
                animation-delay .2s
            */
}
.wave {
  display: block;
  position: absolute;
  top: 30px;
  right: 30px;
}
@media (min-width: 768px) {
  .wave {
    top: 50px;
    right: 40px;
  }
}
.wave .wave-bars {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
}
.wave .wave-bars div {
  min-height: 3px;
  width: 3px;
  margin: 0 2px;
  background-color: #000;
  transition: height 0.05s linear;
  border-radius: 3px;
}
@media (max-width: 768px) {
  .wave .wave-bars div:nth-child(15),
  .wave .wave-bars div:nth-child(16),
  .wave .wave-bars div:nth-child(17),
  .wave .wave-bars div:nth-child(18),
  .wave .wave-bars div:nth-child(19),
  .wave .wave-bars div:nth-child(20) {
    display: none;
  }
}
@-moz-keyframes animPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
@-webkit-keyframes animPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
@-o-keyframes animPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
@keyframes animPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
@-moz-keyframes animOsc {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(8deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(-8deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@-webkit-keyframes animOsc {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(8deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(-8deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@-o-keyframes animOsc {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(8deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(-8deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes animOsc {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(8deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(-8deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/bootstrap-styl/bootstrap/mixins/clearfix.styl","webpack://./src/styles/main.styl","webpack://./node_modules/bootstrap-styl/bootstrap/utilities.styl","webpack://./src/styles/components/animations.styl","webpack://./src/styles/components/global.styl","webpack://./src/styles/components/grid.styl","webpack://./src/styles/components/forms.styl","webpack://./src/styles/components/buttons.styl","webpack://./src/styles/components/header.styl","webpack://./src/styles/components/body.styl","webpack://./src/styles/components/footer.styl","webpack://./src/styles/components/sections.styl","webpack://./src/styles/components/articles.styl","webpack://./src/styles/components/swiper.styl","webpack://./src/styles/components/audio.styl"],"names":[],"mappings":"AAYE;;EAEE,cAAQ;EACR,YAAQ;ACXZ;ADaE;EACE,WAAM;ACXV;ACSA;EACE,uBAAM;ADPR;ACSA;EACE,sBAAM;ADPR;ACcA;EACE,wBAAQ;ADZV;ACcA;EACE,yBAAQ;ADZV;ACcA;EACE,kBAAW;ADZb;ACsBA;EACE,wBAAQ;ADpBV;AC0BA;EACE,eAAS;ADxBX;AEpBA;EACI;IACI,UAAQ;EFuBd;AACF;AE1BA;EACI;IACI,UAAQ;EF4Bd;AACF;AE/BA;EACI;IACI,UAAQ;EFiCd;AACF;AEpCA;EACI;IACI,UAAQ;EFsCd;AACF;AErCA;EACI;IACI,UAAQ;EFuCd;AACF;AE1CA;EACI;IACI,UAAQ;EF4Cd;AACF;AE/CA;EACI;IACI,UAAQ;EFiDd;AACF;AEpDA;EACI;IACI,UAAQ;EFsDd;AACF;AEpDA;EACI;IACI,6BAAU;EFsDhB;AACF;AEzDA;EACI;IACI,6BAAU;EF2DhB;AACF;AE9DA;EACI;IACI,6BAAU;EFgEhB;AACF;AEnEA;EACI;IACI,6BAAU;EFqEhB;AACF;AEpEA;EACI;IACI,6BAAU;EFsEhB;AACF;AEzEA;EACI;IACI,6BAAU;EF2EhB;AACF;AE9EA;EACI;IACI,6BAAU;EFgFhB;AACF;AEnFA;EACI;IACI,6BAAU;EFqFhB;AACF;AEnFA;EACI;IACI,8BAAU;EFqFhB;AACF;AExFA;EACI;IACI,8BAAU;EF0FhB;AACF;AE7FA;EACI;IACI,8BAAU;EF+FhB;AACF;AElGA;EACI;IACI,8BAAU;EFoGhB;AACF;AEnGA;EACI;IACI,8BAAU;EFqGhB;AACF;AExGA;EACI;IACI,8BAAU;EF0GhB;AACF;AE7GA;EACI;IACI,8BAAU;EF+GhB;AACF;AElHA;EACI;IACI,8BAAU;EFoHhB;AACF;AGhJA;EACI,sBAAW;AHkJf;AGhJA;EACI,SAAO;EACP,UAAQ;EACR,sBAAiB;EACjB,aAAQ;AHkJZ;AGjJ8B;EAAA;IACtB,aAAQ;EHoJd;AACF;AGnJA;;;;;EACI,uCAAmB;EACnB,eAAU;AHyJd;AGvJA;EACI,WAAM;EACN,qBAAgB;EAChB,qBAAW;AHyJf;AGvJA;EACI,gBAAO;EACP,UAAQ;AHyJZ;AGvJA;EACI,kBAAa;AHyJjB;AGvJA;EACI,UAAQ;EACR,gBAAO;EACP,iBAAU;EACV,gBAAY;AHyJhB;AGxJ8B;EAAA;IACtB,cAAU;EH2JhB;AACF;AG3J8B;EAAA;IACtB,cAAU;EH8JhB;AACF;AG9J+B;EAAA;IACvB,gBAAU;EHiKhB;AACF;AGjKA;EACI,UAAQ;EACR,gBAAO;EACP,gBAAU;EACV,cAAY;AHmKhB;AGlK8B;EAAA;IACtB,cAAU;EHqKhB;AACF;AGrK8B;EAAA;IACtB,cAAU;EHwKhB;AACF;AGxK+B;EAAA;IACvB,gBAAU;EH2KhB;AACF;AG1KA;EACI,UAAQ;EACR,gBAAO;EACP,gBAAU;EACV,cAAY;AH4KhB;AG3K8B;EAAA;IACtB,gBAAU;EH8KhB;AACF;AG9K8B;EAAA;IACtB,cAAU;EHiLhB;AACF;AG9KA;EACI,kBAAa;AHgLjB;AG/KI;EACI,kBAAc;AHiLtB;AGhLQ;EACI,kBAAc;AHkL1B;AGjLA;EACI,WAAM;EACN,YAAO;EACP,cAAQ;EACR,SAAO;EACP,UAAQ;AHmLZ;AGjLA;EACI,0BAAW;EACX,cAAO;AHmLX;AGjLA;EACI,cAAQ;EACR,WAAM;AHmLV;AGjLA;EACI,qBAAQ;EACR,sBAAe;AHmLnB;AGjLA;EACI,iBAAY;AHmLhB;AGjLA;EACI,qBAAQ;EACR,sBAAe;AHmLnB;AG9KA;;EAEI,gBAAY;AHgLhB;AG9KA;EACI,kBAAW;AHgLf;AItRA;EACI,aAAQ;EACR,0BAAsB;EACtB,SAAI;AJwRR;AItR8B;EAAA;IACtB,qCAAsB;EJyR5B;AACF;AIxR+B;EACvB;IACI,qCAAuB;EJ0RjC;EIxRM;IACI,oDAAuB;EJ0RjC;AACF;AIvRA;EACI,aAAQ;EACR,eAAU;EACV,aAAO;AJyRX;AIxRI;EACI,iBAAU;AJ0RlB;AIxRI;EACI,cAAQ;EACR,sBAAW;EACX,aAAQ;EACR,WAAM;AJ0Rd;AIvR8B;EACtB;IACI,UAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,aAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,aAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;EIvRM;IACI,UAAM;EJyRhB;AACF;AKzWA;EACE,qBAAQ;EACR,sBAAe;EACf,eAAO;AL2WT;AKzWA;;EACI,sBAAe;EACf,iBAAY;AL4WhB;AK1WA;EACI,gBAAW;EACX,wBAAmB;EACnB,qBAAgB;EAChB,WAAM;EACN,YAAO;EACP,6BAAiB;EACjB,kCAAQ;EACR,kBAAc;EACd,eAAO;AL4WX;AK1WA;EACI,sBAAiB;EACjB,kBAAa;AL4WjB;AK1WA;EACI,WAAQ;EACR,cAAQ;EACR,UAAM;EACN,YAAO;EACP,sBAAO;EACP,yBAAa;EACb,wBAAU;EACV,aAAO;AL4WX;AK1WA;EACI,gBAAW;EACX,wBAAmB;EACnB,qBAAgB;EAChB,kBAAQ;EACR,sBAAO;AL4WX;AK1WA;EACI,gBAAW;EACX,wBAAmB;EACnB,qBAAgB;EAChB,kBAAQ;EACR,sBAAO;EACP,gBAAU;EACV,0EAAgC;EAChC,qBAAgB;AL4WpB;AKvWA;EACE,wBAAoB;EACpB,2BAAW;EACX,WAAO;EACP,mBAAc;ALyWhB;AKrWA;EACE,wBAAoB;EACpB,gBAAY;EACZ,WAAO;EACP,YAAQ;EACR,gBAAW;EACX,kBAAe;EACf,eAAQ;ALuWV;AKpWA;EACE,WAAO;EACP,YAAQ;EACR,gBAAW;EACX,kBAAe;EACf,eAAQ;ALsWV;AKnWA;EACE,WAAO;EACP,YAAQ;EACR,gBAAW;EACX,kBAAe;EACf,eAAQ;ALqWV;AM1bA;EACI,qBAAQ;EACR,iBAAY;EACZ,uBAAW;EACX,WAAM;EACN,kBAAQ;EACR,sBAAO;EACP,wBAAmB;EACnB,yBAAe;EACf,iBAAY;EACZ,iBAAU;EAIV,eAAO;EACP,mBAAc;EACd,qBAAW;EACX,sBAAe;EACf,iBAAY;ANybhB;AMhc8B;EAAA;IACtB,iBAAU;IACV,mBAAe;ENmcrB;AACF;AM9bI;EACI,gBAAW;EACX,WAAM;ANgcd;AM9bY;EACI,UAAK;ANgcrB;AM/bI;EACI,qBAAQ;EACR,gBAAW;EACX,eAAU;EACV,oBAAe;EACf,iBAAO;ANicf;AM/bI;EACI,gBAAW;EACX,WAAM;ANicd;AM/bI;EACI,cAAQ;EACR,WAAM;EACN,SAAO;ANicf;AM/bI;EACI,SAAO;ANicf;AM/bI;EACI,kBAAQ;ANichB;AO9eA;EACI,mBAAc;EACd,UAAQ;APgfZ;AO9e8B;EAAA;IACtB,gBAAW;IACX,mBAAc;IACd,aAAQ;EPifd;AACF;AOhfI;EACI,iBAAY;EACZ,WAAM;EACN,qBAAgB;EAChB,qBAAQ;EACR,sBAAe;EACf,SAAO;EACP,UAAQ;APkfhB;AOjfQ;EACI,WAAM;EACN,YAAO;APmfnB;AOlfkC;EACtB;IACI,YAAO;EPofrB;AACF;AOnfQ;EACI,eAAU;EACV,aAAQ;APqfpB;AOpfsC;EAAA;IACtB,eAAQ;EPuftB;AACF;AOtfQ;EACI,iBAAY;APwfxB;AOvfqC;EAAA;IACrB,aAAQ;EP0ftB;AACF;AOxfI;EACI,aAAQ;AP0fhB;AOzfiC;EAAA;IACrB,cAAQ;IACR,YAAM;EP4fhB;AACF;AO1fI;EACI,WAAM;EACN,kBAAS;EACT,qBAAQ;EACR,cAAO;EACP,YAAM;AP4fd;AO3fQ;EACI,mBAAc;EACd,mBAAc;EACd,kBAAa;EACb,WAAM;EACN,6BAAiB;AP6f7B;AO5fQ;EACI,kBAAS;EACT,MAAI;EACJ,QAAM;EACN,YAAO;AP8fnB;AO3fI;EACI,YAAQ;AP6fhB;AO3fI;EACI,qBAAQ;EACR,sBAAe;EACf,kBAAa;AP6frB;AO5fkC;EAAA;IACtB,aAAQ;EP+flB;AACF;AO/fQ;EACI,qBAAgB;EAChB,UAAQ;EACR,SAAO;APigBnB;AOhgBY;EACI,kBAAS;EACT,qBAAQ;EACR,SAAO;APkgBvB;AOjgBgB;EACI,eAAU;EACV,WAAM;EACN,qBAAgB;EAChB,cAAQ;EACR,gBAAQ;EACR,oCAAc;APmgBlC;AOlgBoB;EACI,gBAAW;APogBnC;AOlgBoB;EACI,kBAAa;APogBrC;AOngBoB;EACI,cAAQ;APqgBhC;AOpgBgB;EACI,kBAAS;EACT,SAAI;EACJ,QAAM;EACN,gBAAU;EACV,aAAQ;EACR,2BAAU;EACV,UAAQ;APsgB5B;AOrgB8C;EAAA;IACtB,sBAAM;EPwgB5B;AACF;AOxgBoB;EACI,gBAAW;AP0gBnC;AOzgBwB;EACI,gBAAW;EACX,sBAAO;EAEP,kBAAQ;AP0gBpC;AOzgB4B;EACI,gBAAW;EACX,WAAM;AP2gBtC;AOxgBI;EACI,YAAM;EACN,iBAAQ;EACR,eAAW;EACX,cAAQ;EACR,eAAO;AP0gBf;AOzgBkC;EAAA;IACtB,aAAQ;EP4gBlB;AACF;AO5gBQ;EACI,qBAAQ;EACR,sBAAe;EACf,iBAAa;AP8gBzB;AO7gBY;EACI,WAAM;EACN,WAAO;EACP,gBAAW;EACX,aAAO;EACP,cAAQ;AP+gBxB;AO7gBI;EACI,eAAS;EACT,MAAI;EACJ,OAAK;EACL,WAAM;EACN,YAAO;EAEP,YAAQ;EACR,aAAQ;EACR,gBAAS;AP8gBjB;AO7gBQ;EACI,cAAQ;AP+gBpB;AO7gBY;EACI,sCAAU;AP+gB1B;AO9gBkC;EAAA;IACtB,aAAQ;EPihBlB;AACF;AO/gBQ;EACI,gBAAW;EACX,kBAAS;EACT,YAAO;EACP,cAAS;EACT,8BAAU;EACV,aAAQ;APihBpB;AO9gBQ;EACI,kBAAS;EACT,SAAI;EACJ,WAAM;EACN,kBAAQ;EACR,eAAO;APghBnB;AO9gBQ;EACI,mBAAc;APghB1B;AO/gBY;EACI,gBAAW;EACX,UAAQ;EACR,SAAO;APihBvB;AOhhBgB;EACI,UAAQ;EACR,SAAO;APkhB3B;AOjhBoB;EACI,cAAQ;EACR,sBAAO;EACP,kBAAQ;EACR,gBAAW;APmhBnC;AOjhBQ;EACI,mBAAc;APmhB1B;AOhhBQ;EACI,kBAAW;APkhBvB;AOhhBY;EACI,qBAAQ;EACR,kBAAQ;EACR,sBAAe;APkhB/B;AOjhBgB;EACI,YAAO;EACP,gBAAU;EACV,gBAAW;EACX,WAAM;APmhB1B;AQztBA;EACI,aAAQ;AR2tBZ;AQztBI;EACI,yBAAQ;EACR,2BAAU;AR2tBlB;ASjuBA;EACI,wBAAO;EACP,gBAAW;EACX,aAAQ;EACR,iBAAU;EACV,kBAAW;ATmuBf;ASluB6B;EAAA;IACrB,gBAAO;IACP,gBAAU;ETquBhB;AACF;ASruBI;EACI,cAAQ;EACR,aAAO;ATuuBf;AStuBiC;EAAA;IACrB,qBAAQ;IACR,aAAO;ETyuBjB;AACF;ASzuBI;EACI,aAAQ;AT2uBhB;AS1uBiC;EAAA;IACrB,qBAAQ;ET6uBlB;AACF;AS5uBI;EACI,mBAAc;AT8uBtB;AS1uBQ;EACI,YAAO;EACP,qBAAQ;EACR,sBAAe;AT4uB3B;AS3uBY;EACI,WAAM;EACN,gBAAU;EACV,cAAO;AT6uBvB;AS3uBgB;EACI,gBAAW;AT6uB/B;AS3uBI;EACI,gBAAU;EACV,mBAAO;AT6uBf;AS1uBQ;EACI,6BAAc;AT4uB1B;AUjxBA;EACI,mBAAc;AVmxBlB;AUlxBI;EACI,gBAAc;AVoxBtB;AUjxBI;EACI,gBAAY;EACZ,mBAAc;AVmxBtB;AUlxBkC;EAAA;IACtB,iBAAU;IACV,kBAAc;EVqxBxB;AACF;AUrxBQ;EACI,qBAAQ;EACR,6BAAc;AVuxB1B;AUrxB0C;EAAA;IACtB,cAAQ;IACR,gBAAc;EVwxBhC;AACF;AUxxBQ;EACI,iBAAO;EACP,gBAAU;AV0xBtB;AUzxBsC;EAAA;IACtB,cAAY;EV4xB1B;AACF;AU3xBQ;EACI,YAAQ;AV6xBpB;AU5xBQ;EACI,YAAQ;EACR,yBAAa;AV8xBzB;AU7xBY;EACI,UAAQ;EACR,kBAAa;AV+xB7B;AU9xBkC;EAAA;IACtB,gBAAW;EViyBrB;EUhyBU;;IAEI,aAAQ;EVkyBtB;AACF;AUhyBI;EACI,gBAAW;EACX,aAAQ;AVkyBhB;AUjyBkC;EAAA;IACtB,aAAQ;EVoyBlB;AACF;AUpyBkC;EAAA;IACtB,aAAQ;EVuyBlB;AACF;AUpyBI;EACI,mBAAc;EACd,kBAAS;AVsyBjB;AUryBkC;EAAA;IACtB,eAAO;EVwyBjB;AACF;AUvyBQ;EACI,mBAAc;AVyyB1B;AUxyBsC;EAAA;IACtB,mBAAc;IACd,aAAQ;IACR,cAAS;IACT,8BAAsB;EV2yBpC;AACF;AUzyB0C;EAAA;IACtB,mBAAc;EV4yBhC;AACF;AU3yBgB;EACI,kBAAS;AV6yB7B;AU5yB8C;EAAA;IACtB,cAAU;EV+yBhC;AACF;AU/yB8C;EAAA;IACtB,mBAAc;EVkzBpC;AACF;AUjzBgB;EACI,gBAAU;EACV,gBAAc;AVmzBlC;AUhzB+C;EAAA;IACvB,iBAAU;EVmzBhC;AACF;AUnzBoB;EACI,SAAO;AVqzB/B;AUlzBY;EACI,aAAO;EACP,oBAAO;EACP,gBAAO;EACP,sBAAO;EACP,kBAAS;AAaT;;;;iBV2yBC;AACjB;AUxzB0C;EAAA;IACtB,WAAM;IACN,mBAAe;IACf,SAAO;IACP,SAAO;EV2zBzB;AACF;AU/yBgB;EACI,cAAQ;EACR,kBAAS;EACT,MAAI;EACJ,OAAK;EACL,sBAAM;EACN,uBAAO;EACP,YAAO;AVizB3B;AU/yBQ;EACI,kBAAS;EACT,gBAAW;AVizBvB;AUhzBY;EACI,eAAU;AVkzB1B;AUjzBsC;EAAA;IACtB,eAAa;EVozB3B;AACF;AUhzBQ;EACI,gBAAW;AVkzBvB;AU9yBkC;EAAA;IACtB,eAAO;EVizBjB;AACF;AUhzBQ;EAOI,mBAAc;AV4yB1B;AUlzBsC;EAAA;IACtB,eAAa;IACb,gBAAW;EVqzBzB;AACF;AUrzB0C;EAAA;IAC1B,eAAa;IACb,gBAAW;EVwzBzB;AACF;AUtzBY;EACI,kBAAe;AVwzB/B;AUvzBgB;EACI,gBAAc;AVyzBlC;AUxzBgB;EACI,iBAAU;AV0zB9B;AUxzBsC;EAEtB;IACI,gBAAU;EVyzB5B;AACF;AUpzBQ;EACI,mBAAc;EACd,kBAAQ;EACR,gBAAW;AVszBvB;AUjyBkC;EAAA;IACtB,eAAO;IACP,aAAQ;EVoyBlB;AACF;AUlyBQ;EACI,aAAQ;EACR,eAAU;EACV,SAAI;EACJ,mBAAO;AVoyBnB;AUnyBsC;EAAA;IACtB,SAAI;EVsyBlB;AACF;AUtyBsC;EAAA;IACtB,SAAI;EVyyBlB;AACF;AUxyBY;EACI,0BAAW;EACX,iBAAY;EACZ,SAAO;EACP,OAAK;EACL,sBAAW;EACX,gBAAU;AV0yB1B;AUzyB0C;EAAA;IACtB,iBAAY;EV4yB9B;AACF;AU5yB0C;EAAA;IACtB,gBAAU;EV+yB5B;AACF;AU/yBgB;EACI,cAAQ;EACR,YAAQ;EACR,mBAAY;EACZ,cAAY;EACZ,kBAAc;EAEd,gBAAU;AVgzB9B;AU/yBgB;EACI,cAAQ;EACR,mBAAa;EACb,WAAO;EACP,gBAAW;AVizB/B;AUhzB8C;EAAA;IACtB,gBAAW;EVmzBjC;AACF;AUhzBgB;EACI,aAAQ;EACR,SAAI;AVkzBxB;AUjzBoB;EACI,SAAO;AVmzB/B;AUhzBQ;EACI,eAAO;AVkzBnB;AUjzBsC;EAAA;IACtB,eAAO;EVozBrB;AACF;AUpzBsC;EAAA;IACtB,SAAO;EVuzBrB;AACF;AUtzBQ;EACI,mBAAW;EACX,eAAO;AVwzBnB;AUvzBsC;EAAA;IACtB,SAAO;EV0zBrB;AACF;AU1zBY;EACI,oBAAQ;AV4zBxB;AU3zBY;EACI,SAAO;AV6zBvB;AU5zBY;EACI,SAAO;AV8zBvB;AU3zBQ;EACI,kBAAS;EACT,oBAAe;EACf,aAAO;EAIP,YAAO;AV0zBnB;AU7zBuC;EAAA;IACvB,YAAO;IACP,kCAAsB;EVg0BpC;AACF;AU/zBY;EACI,kBAAS;EACT,MAAI;EACJ,OAAK;EACL,sBAAM;EACN,uBAAO;EACP,yBAAiB;AVi0BjC;AU/zBY;EACI,kBAAU;EACV,YAAQ;EACR,SAAM;EACN,WAAO;EACP,kBAAW;AVi0B3B;AU/zB8C;EACtB;IACI,YAAM;EVi0BhC;AACF;AUh0BY;EACI,YAAQ;EACR,qBAAQ;AVk0BxB;AUj0BgB;EACI,sBAAe;AVm0BnC;AUl0BgB;EACI,YAAM;AVo0B1B;AUl0BY;EACI,kBAAS;EACT,mBAAsB;AVo0BtC;AUh0BQ;EACI,yBAAiB;EACjB,aAAQ;AVk0BpB;AUj0BuC;EAAA;IACvB,aAAQ;EVo0BtB;AACF;AUj0BQ;EACI,kBAAS;EACT,aAAQ;EACR,yBAAiB;AVm0B7B;AUj0BY;;;EACI,aAAW;AVq0B3B;AUp0BY;EACI,gBAAU;AVs0B1B;AUp0BY;EACI,0BAAgB;EAChB,qBAAU;EACV,qBAAY;EACZ,gBAAS;EACT,uBAAc;EACd,kBAAY;AVs0B5B;AUn0B0C;EAAA;IACtB,aAAS;EVs0B3B;AACF;AUp0B0C;EAAA;IACtB,gBAAU;EVu0B5B;AACF;AUn0BY;EACI,gBAAc;AVq0B9B;AWtpCA;EACI,gBAAW;EACX,eAAQ;EACR,gBAAS;EAET,kBAAS;EACT,0BAAW;AAIX;;;;KXupCC;AACL;AW3pC+B;EAAA;IACvB,eAAQ;EX8pCd;AACF;AWtpCI;EACI,mBAAc;EACd,eAAU;AXwpClB;AWtpCI;EACI,gBAAU;AXwpClB;AWrpCkC;EAAA;IACtB,kBAAS;IACT,YAAO;IACP,WAAM;EXwpChB;AACF;AWvpCI;EACI,cAAO;AXypCf;AWtpCQ;EACI,aAAQ;EACR,eAAU;EACV,YAAO;AXwpCnB;AWvpCY;EACI,UAAM;EACN,YAAQ;AXypCxB;AWrpCA;EACI,kBAAU;EACV,+BAAa;EACb,eAAQ;EACR,sBAAO;AXupCX;AWrpCI;EACI,kBAAS;AXupCjB;AWrpCI;EACI,aAAS;EACT,0BAAW;EACX,sBAAW;AXupCnB;AWrpCI;EACI,gBAAY;EACZ,SAAO;EACP,YAAQ;AXupChB;AWrpCI;EACI,kBAAS;EACT,SAAO;EACP,QAAM;EACN,SAAO;EACP,aAAQ;EACR,WAAM;EACN,mBAAe;EACf,yBAAe;EACf,gBAAU;EACV,iBAAY;EACZ,YAAQ;EACR,qBAAW;AXupCnB;AWrpCQ;EACI,UAAQ;AXupCpB;AWrpCI;EACI,SAAO;EACP,UAAQ;EACR,gBAAU;EACV,gBAAY;AXupCpB;AWtpCQ;EACI,WAAM;EACN,qBAAgB;AXwpC5B;AWvpCY;EACI,cAAQ;EACR,WAAQ;EACR,kBAAS;EACT,MAAI;EACJ,OAAK;EACL,WAAM;EACN,YAAO;AXypCvB;AWxpCY;EACI,mBAAY;AX0pC5B;AWvpCI;EACI,kBAAU;EACV,MAAK;EACL,OAAM;EACN,WAAO;EACP,YAAQ;EACR,aAAS;EACT,uBAAiB;EACjB,mBAAa;EACb,4CAAU;AXypClB;AWxpCQ;EACI,cAAQ;EACR,sBAAO;EACP,uBAAQ;AX0pCpB;AWvpCI;EACI,cAAQ;AXypChB;AY5wCA;EACI,kBAAS;EACT,iBAAY;EACZ,gBAAS;AZ8wCb;AY5wCA;EACI,aAAQ;EACR,QAAI;EACJ,eAAO;AZ8wCX;AY5wCI;EACI,eAAO;EACP,YAAQ;EACR,qBAAW;EACX,kBAAS;AZ8wCjB;AY7wCQ;EACI,UAAQ;EACR,UAAQ;AZ+wCpB;AY9wCY;EACI,WAAQ;EACR,cAAQ;EACR,kBAAS;EACT,MAAI;EACJ,OAAK;EACL,WAAM;EACN,YAAO;EACP,sBAAO;EACP,sBAAW;AZgxC3B;AY/wCQ;EACI,UAAQ;AZixCpB;AY/wCI;EACI,aAAQ;EAER,MAAI;EAEJ,SAAO;EACP,eAAU;AZ+wClB;AY7wCQ;EAEI,aAAM;EACN,sBAAW;AZ8wCvB;AY3wCA;;EACI,sBAAM;EACN,YAAQ;EACR,qBAAW;AZ8wCf;AY7wCI;;EACI,UAAQ;AZgxChB;AY7wCA;EACI,gBAAW;AZ+wCf;Aal0CA;EACI,eAAS;EACT,MAAI;EACJ,OAAK;EACL,WAAM;EACN,YAAO;EACP,4BAAW;EAEX,WAAQ;EACR,aAAQ;EACR,2BAAU;EACV,kBAAW;Abm0Cf;Aaj0CI;EACI,kBAAS;EACT,MAAI;EACJ,OAAK;EACL,WAAM;EACN,YAAO;EACP,gBAAW;EACX,aAAQ;EACR,sBAAW;EACX,cAAS;Abm0CjB;Aal0CkC;EAAA;IACtB,6BAAU;IACV,gBAAU;IACV,mBAAY;IACZ,QAAI;IACJ,SAAK;IACL,YAAO;Ebq0CjB;AACF;Aap0CI;EACI,kBAAS;EACT,MAAI;EACJ,QAAM;EACN,aAAQ;EACR,eAAO;EACP,aAAQ;EACR,qBAAW;Abs0CnB;Aar0CQ;EACI,UAAQ;Abu0CpB;Aap0CI;EACI,gBAAW;EACX,WAAM;EACN,sBAAO;EACP,eAAO;EACP,YAAM;EACN,aAAO;EACP,oBAAc;EACd,UAAQ;EACR,SAAO;EACP,yBAAe;EACf,qBAAW;EACX,iBAAY;EACZ,kBAAS;EACT,MAAI;Abs0CZ;Aar0CQ;EACI,WAAQ;EACR,cAAQ;EACR,WAAM;EACN,YAAO;EACP,kBAAS;EACT,SAAI;EACJ,UAAK;EACL,sBAAW;EACX,sBAAO;EACP,oBAAc;EACd,uCAAU;EACV,UAAQ;EACR,qBAAW;Abu0CvB;Aar0CY;EACI,UAAQ;Abu0CxB;Aat0CQ;EACI,sBAAU;Abw0CtB;Aav0CQ;EACI,gBAAW;EACX,WAAM;Aby0ClB;Aav0CI;EACI,cAAO;Aby0Cf;Aav0CI;EACI,cAAQ;EACR,sBAAQ;EACR,aAAS;EACT,mBAAe;Aby0CvB;Aav0CQ;EACI,WAAM;EACN,WAAM;EACN,gBAAY;EACZ,iBAAa;Aby0CzB;Aav0CQ;EACI,iBAAa;EACb,gBAAY;EACZ,WAAQ;EACR,kBAAe;EACf,iBAAY;Aby0CxB;Aav0CI;EACI,cAAQ;Aby0ChB;Aav0CI;EACI,aAAQ;EACR,gBAAW;EACX,iBAAY;EACZ,gBAAW;EACX,iBAAU;Aby0ClB;Aax0CQ;EACI,gBAAc;Ab00C1B;Aaz0CQ;EACI,kBAAc;Ab20C1B;Aa10CQ;EACI,eAAO;Ab40CnB;Aa30CQ;EACI,aAAQ;Ab60CpB;Aa/zCA;EACI,cAAQ;EACR,gBAAU;EACV,iBAAO;Abi0CX;Aa/zCI;EACI,UAAM;EACN,eAAQ;EACR,qBAAgB;EAChB,sBAAiB;EACjB,iBAAc;EACd,YAAQ;EACR,yBAAiB;EACjB,yBAAW;Abi0CnB;Aah0CQ;EACI,wCAAU;AACV;;;;;;;;;;;;;;;;;;;;;abs1CC;AACb;AarzCA;EACI,cAAS;EAET,kBAAU;EACV,SAAK;EACL,WAAO;AbszCX;AarzC8B;EAAA;IACtB,SAAK;IACL,WAAO;EbwzCb;AACF;AatzCI;EACI,YAAQ;EACR,aAAS;EACT,mBAAa;EACb,uBAAiB;EACjB,mBAAa;AbwzCrB;AavzCQ;EACI,eAAY;EACZ,UAAO;EACP,aAAQ;EACR,sBAAkB;EAClB,+BAAY;EACZ,kBAAe;AbyzC3B;AavzCkC;EACtB;;;;;;IAMI,aAAS;EbyzCvB;AACF;Aa3hDA;EACI;IACI,mBAAU;Eb6hDhB;Ea5hDE;IACI,sBAAU;Eb8hDhB;AACF;AaniDA;EACI;IACI,mBAAU;EbqiDhB;EapiDE;IACI,sBAAU;EbsiDhB;AACF;Aa3iDA;EACI;IACI,mBAAU;Eb6iDhB;Ea5iDE;IACI,sBAAU;Eb8iDhB;AACF;AanjDA;EACI;IACI,mBAAU;EbqjDhB;EapjDE;IACI,sBAAU;EbsjDhB;AACF;Aax7CA;EACI;IACI,uBAAU;Eb07ChB;Eaz7CE;IACI,uBAAU;Eb27ChB;Ea17CE;IACI,uBAAU;Eb47ChB;Ea37CE;IACI,wBAAU;Eb67ChB;Ea57CE;IACI,uBAAU;Eb87ChB;AACF;Aaz8CA;EACI;IACI,uBAAU;Eb28ChB;Ea18CE;IACI,uBAAU;Eb48ChB;Ea38CE;IACI,uBAAU;Eb68ChB;Ea58CE;IACI,wBAAU;Eb88ChB;Ea78CE;IACI,uBAAU;Eb+8ChB;AACF;Aa19CA;EACI;IACI,uBAAU;Eb49ChB;Ea39CE;IACI,uBAAU;Eb69ChB;Ea59CE;IACI,uBAAU;Eb89ChB;Ea79CE;IACI,wBAAU;Eb+9ChB;Ea99CE;IACI,uBAAU;Ebg+ChB;AACF;Aa3+CA;EACI;IACI,uBAAU;Eb6+ChB;Ea5+CE;IACI,uBAAU;Eb8+ChB;Ea7+CE;IACI,uBAAU;Eb++ChB;Ea9+CE;IACI,wBAAU;Ebg/ChB;Ea/+CE;IACI,uBAAU;Ebi/ChB;AACF","sourcesContent":["// Clearfix\n//\n// For modern browsers\n// 1. The space content is one way to avoid an Opera bug when the\n// contenteditable attribute is included anywhere else in the document.\n// Otherwise it causes space to appear at the top and bottom of elements\n// that are clearfixed.\n// 2. The use of `table` rather than `block` is only necessary if using\n// `:before` to contain the top-margins of child elements.\n//\n// Source http://nicolasgallagher.com/micro-clearfix-hack/\nclearfix()\n  &:before,\n  &:after\n    display table // 2\n    content \" \" // 1\n\n  &:after\n    clear both\n","\n// -----------------------------\n// VARS ------------------------\n// -----------------------------\n\n\n$mobile = 480px\n$tablet = 768px\n$desktop = 1024px\n$desktop-lg = 1440px\n\n@import '../../node_modules/bootstrap-styl/bootstrap/variables'\n@import '../../node_modules/bootstrap-styl/bootstrap/mixins/clearfix'\n@import '../../node_modules/bootstrap-styl/bootstrap/mixins/grid-framework'\n@import '../../node_modules/bootstrap-styl/bootstrap/mixins/grid'\n@import '../../node_modules/bootstrap-styl/bootstrap/utilities'\n\n@import '../../node_modules/font-awesome/css/font-awesome.css'\n\n\n@import 'components/animations'\n@import 'components/global'\n@import 'components/grid'\n@import 'components/forms'\n@import 'components/buttons'\n@import 'components/header'\n@import 'components/body'\n@import 'components/footer'\n@import 'components/sections'\n@import 'components/articles'\n@import 'components/swiper'\n@import 'components/audio'\n\n","// stylelint-disable declaration-no-important\n\n//\n// Utility classes\n// --------------------------------------------------\n\n\n// Floats\n// -------------------------\n\n.clearfix\n  clearfix()\n\n.center-block\n  center-block()\n\n.pull-right\n  float right !important\n\n.pull-left\n  float left !important\n\n\n// Toggling content\n// -------------------------\n\n// Note Deprecated .hide in favor of .hidden or .sr-only (as appropriate) in v3.0.1\n.hide\n  display none !important\n\n.show\n  display block !important\n\n.invisible\n  visibility hidden\n\n.text-hide\n  text-hide()\n\n\n// Hide from screenreaders and browsers\n//\n// Credit HTML5 Boilerplate\n\n.hidden\n  display none !important\n\n\n// For Affix plugin\n// -------------------------\n\n.affix\n  position fixed\n","\n\n\n// -----------------------------\n// Animations ------------------\n// -----------------------------\n\n\n@keyframes fadeIn\n    0%\n        opacity 0\n\n@keyframes fadeOut\n    100%\n        opacity 0\n\n\n@keyframes slideLeft\n    0%\n        transform translate(100%,0)\n\n@keyframes slideLeftOut\n    100%\n        transform translate(100%,0)\n\n\n@keyframes slideRight\n    0%\n        transform translate(-100%,0)\n\n@keyframes slideRightOut\n    100%\n        transform translate(-100%,0)\n","\n// -----------------------------\n// Global styles ---------------\n// -----------------------------\n\n*\n    box-sizing border-box\n\nbody\n    margin 0\n    padding 0\n    background-color #eee\n    padding 20px\n    @media (min-width: $tablet)\n        padding 30px\n\nbody,button,input,textarea,select\n    font-family Poppins, Arial, sans-serif\n    font-size 15px\n\na\n    color black\n    text-decoration none\n    transition .2s ease\n\np\n    margin 0 0 20px\n    padding 0\n\nol\n    padding-left 16px\n\nh1\n    padding 0\n    margin 0 0 20px\n    font-size 2.25em\n    line-height 1.1\n    @media (min-width: $mobile)\n        font-size 3em\n    @media (min-width: $tablet)\n        font-size 4em\n    @media (min-width: $desktop)\n        font-size 4.4em\nh2\n    padding 0\n    margin 0 0 20px\n    font-size 1.5em\n    line-height 1\n    @media (min-width: $mobile)\n        font-size 2em\n    @media (min-width: $tablet)\n        font-size 3em\n    @media (min-width: $desktop)\n        font-size 3.5em\n\nh3\n    padding 0\n    margin 0 0 20px\n    font-size 1.2em\n    line-height 1\n    @media (min-width: $mobile)\n        font-size 1.5em\n    @media (min-width: $tablet)\n        font-size 2em\n    \n\n\nul\n    padding-left 20px\n    li\n        margin-bottom 5px\n        &:last-child\n            margin-bottom 0px\nimg\n    width 100%\n    height auto\n    display block\n    margin 0\n    padding 0\n\nhr\n    border-top 1px solid black\n    margin 30px 0\n\nvideo\n    display block\n    width 100%\n\naudio\n    display inline-block\n    vertical-align middle\n\nbutton\n    user-select none\n\n.fa\n    display inline-block\n    vertical-align middle\n\n\n// HELPERS -----------------\n\n.h--400,\n.text--400\n    font-weight 400\n\n.text--center\n    text-align center","// -----------------------------\n// Grid ------------------\n// -----------------------------\n\n\n.grid\n    display grid\n    grid-template-columns 1fr  // Una sola columna en pantallas pequeñas (mobile first)\n    gap 30px\n\n    @media (min-width: $tablet)\n        grid-template-columns repeat(2, 1fr)\n\n    @media (min-width: $desktop)\n        &.grid--3\n            grid-template-columns: repeat(3, 1fr)   // Tres columnas iguales\n\n        &.grid--catalog\n            grid-template-columns: repeat(3, minmax(300px, 1fr))\n\n\n\n.flex\n    display flex\n    flex-wrap wrap\n    margin -15px\n    &.flex--auto\n        flex-wrap nowrap\n\n    &>div\n        display block\n        box-sizing border-box\n        padding 15px\n        width 100%  // Una columna por defecto (mobile first)\n\n    // Media query para tablet (dos columnas)\n    @media (min-width: $tablet)\n        .flex__20\n            width 20%\n\n        .flex__25\n            width 25%\n\n        .flex__30\n            width 30%\n\n        .flex__33\n            width 33.33%\n\n        .flex__35\n            width 35%\n\n        .flex__40\n            width 40%\n\n        .flex__45\n            width 45%\n\n        .flex__50\n            width 50%\n\n        .flex__55\n            width 55%\n\n        .flex__60\n            width 60%\n\n        .flex__65\n            width 65%\n\n        .flex__66\n            width 66.66%\n\n        .flex__70\n            width 70%\n\n        .flex__75\n            width 75%\n\n        .flex__80\n            width 80%\n\n\n","\nlabel\n  display inline-block\n  vertical-align middle\n  cursor pointer\n\ninput,select\n    vertical-align middle\n    line-height 20px\n\ninput[type=\"checkbox\"]\n    appearance none\n    -webkit-appearance none\n    -moz-appearance none\n    width 20px\n    height 20px\n    background-color transparent\n    border: 2px solid rgba(0,0,0,.25)\n    border-radius 3px\n    cursor pointer\n\ninput[type=\"checkbox\"]:checked\n    background-color black\n    border-color black\n\ninput[type=\"checkbox\"]:checked::after\n    content \"\"\n    display block\n    width 6px\n    height 10px\n    border 2px solid white\n    border-width 0 2px 2px 0\n    transform rotate(45deg)\n    margin 0 3px\n\ninput[type='text']\n    appearance none\n    -webkit-appearance none\n    -moz-appearance none\n    padding 10px 15px\n    border 2px solid black\n\nselect\n    appearance none\n    -webkit-appearance none\n    -moz-appearance none\n    padding 10px 15px\n    border 2px solid black\n    min-width 120px\n    background url(../img/select.png) right center no-repeat\n    background-size 30px\n\n\n\n// Estilos generales para el contenedor del slider\ninput[type=\"range\"]\n  -webkit-appearance: none // Eliminar estilo predeterminado de Webkit\n  background rgba(0,0,0,.2)\n  height 4px\n  border-radius 20px\n\n\n// Estilos para el thumb del slider\ninput[type=\"range\"]::-webkit-slider-thumb\n  -webkit-appearance: none // Eliminar estilo predeterminado de Webkit\n  appearance: none // Eliminar estilo predeterminado\n  width: 20px // Ancho del thumb\n  height: 20px // Altura del thumb\n  background black\n  border-radius: 50% // Hacer el thumb redondo\n  cursor: pointer // Cambiar cursor al pasar sobre el thumb\n\n// Estilos para el thumb en otros navegadores\ninput[type=\"range\"]::-moz-range-thumb\n  width: 20px // Ancho del thumb\n  height: 20px // Altura del thumb\n  background black\n  border-radius: 50% // Hacer el thumb redondo\n  cursor: pointer // Cambiar cursor al pasar sobre el thumb\n\n// Estilos para el thumb en Edge\ninput[type=\"range\"]::-ms-thumb\n  width: 20px // Ancho del thumb\n  height: 20px // Altura del thumb\n  background black\n  border-radius: 50% // Hacer el thumb redondo\n  cursor: pointer // Cambiar cursor al pasar sobre el thumb\n\n","\n.btn\n    display inline-block\n    user-select none\n    background transparent\n    color black\n    padding 10px 20px\n    border 2px solid black\n    -webkit-appearance none\n    text-transform uppercase\n    font-weight bold\n    font-size .85em\n    @media (min-width: $tablet)\n        font-size .95em\n        letter-spacing 1px\n    cursor pointer\n    border-radius 30px\n    transition .2s ease\n    vertical-align middle\n    line-height 20px\n    &:hover\n        background black\n        color white\n        svg\n            path\n                fill white\n    svg\n        display inline-block\n        max-height 16px\n        max-width 16px\n        vertical-align -4px\n        margin 0 5px 0 0\n\n    &.btn--black\n        background black\n        color white\n\n    &.btn--block\n        display block\n        width 100%\n        margin 0\n\n    &.btn--link\n        border 0\n\n    &.btn--md\n        padding 12px 25px","\nheader\n    margin-bottom 20px\n    padding 0\n    //font-size 20px\n    @media (min-width: $tablet)\n        background white\n        margin-bottom 30px\n        padding 20px\n\n    .header__logo\n        font-weight bold\n        color black\n        text-decoration none\n        display inline-block\n        vertical-align middle\n        margin 0\n        padding 0\n        img\n            width auto\n            height 60px\n        @media (min-width: $tablet)\n            img\n                height 70px\n\n        &.header__logo--tecnologiasdelagua\n            font-size 120%\n            padding 20px\n            @media (max-width: $tablet)\n                padding 10px 0\n\n        &.header__logo--facultad\n            margin-left 20px\n            @media (max-width: 1600px)\n                display none\n\n    \n    .header__right\n        display none\n        @media (min-width: 1060px)\n            display block\n            float right\n\n\n    .header__search\n        width 100%\n        position relative\n        display inline-block\n        margin 15px 0\n        width 300px\n        input\n            border-radius 30px\n            padding-right 40px\n            padding-left 20px\n            width 100%\n            background-color transparent\n        button\n            position absolute\n            top 0\n            right 0\n            height 100%\n\n\n    .header__bread\n        opacity .4\n\n    .header__nav\n        display inline-block\n        vertical-align middle\n        margin-right 20px\n        @media (max-width: $tablet)\n            display none\n        ul\n            list-style-type none\n            padding 0\n            margin 0\n            li\n                position relative\n                display inline-block\n                margin 0\n                a\n                    font-size 16px\n                    color black\n                    text-decoration none\n                    display block\n                    padding 5px 5px\n                    border-bottom 2px solid transparent\n                    .fa\n                        margin-top -2px\n                &:hover\n                    &>a\n                        border-color black\n                    ul\n                        display block\n                ul\n                    position absolute\n                    top 100%\n                    right 0\n                    min-width 320px\n                    display none\n                    animation fadeIn .5s ease\n                    z-index 2\n                    @media (max-width: $mobile)\n                        width calc(100vh-20)\n                    li\n                        margin-top -2px\n                        a\n                            background white\n                            border 2px solid black\n                            //@media (min-width: $tablet)\n                            padding 10px 15px\n                            &:hover\n                                background black\n                                color white\n\n\n    .header__hamburger\n        float right\n        padding 10px 5px\n        margin-top 5px\n        display block\n        cursor pointer\n        @media (min-width: $tablet)\n            display none\n        div\n            display inline-block\n            vertical-align middle\n            margin-right 5px\n            div\n                width 30px\n                height 2px\n                background black\n                margin 3px 0\n                display block\n\n    .header__menu\n        position fixed\n        top 0\n        left 0\n        width 100%\n        height 100%\n        //animation fadeIn .5s ease\n        z-index 100\n        display none\n        overflow hidden\n        &._open\n            display block\n        &._closing\n            .header__menu__\n                animation slideLeftOut .5s ease both\n        @media (min-width: $tablet)\n            display none\n            \n\n        .header__menu__\n            background white\n            position relative\n            height 100%\n            overflow auto\n            animation slideLeft .5s ease\n            padding 25px\n        \n\n        .header__menu__close\n            position absolute\n            top 10px\n            right 10px\n            padding 15px 20px\n            cursor pointer\n\n        .header__menu__items\n            margin-bottom 20px\n            ul\n                list-style none\n                padding 0\n                margin 0\n                li\n                    padding 0\n                    margin 0\n                    a\n                        display block\n                        border 2px solid black\n                        padding 10px 15px\n                        margin-top -2px\n\n        .header__menu__search\n            margin-bottom 20px\n        \n\n        .header__menu__logos\n            text-align center\n\n            .header__logo\n                display inline-block\n                padding 15px 10px\n                vertical-align middle\n                img\n                    height auto\n                    max-width 160px\n                    max-height 80px\n                    width 100%\n","\n\n#body\n    display none\n\n    &.body--loaded\n        display block !important\n        animation fadeIn .5s ease\n","\nfooter\n    margin 30px -20px -20px\n    background white\n    padding 30px\n    font-size .85em\n    text-align center\n    @media (min-width:$tablet)\n        margin 30px 0 0\n        font-size .9em\n    a\n        display block\n        margin 5px 0\n        @media (min-width:$tablet)\n            display inline-block\n            margin 0 6px\n    span\n        display none\n        @media (min-width:$tablet)\n            display inline-block\n\n    .footer__logos\n        margin-bottom 30px\n        //@media (min-width:$tablet)\n        //    display none\n\n        .footer__logo\n            margin 20px\n            display inline-block\n            vertical-align middle\n            img\n                width auto\n                max-width 180px\n                margin 0 auto\n            &.footer__logo--depto\n                img\n                    max-height 90px\n\n    .footer__credit\n        max-width 800px\n        margin 0 auto 20px \n    \n    .footer__links\n        a\n            border-bottom 1px solid black\n\n","\n\n// -----------------------------\n// SECTIONS --------------------\n// -----------------------------\n\n\nsection\n    margin-bottom 30px\n    &:last-child\n        margin-bottom 0\n    \n\n    .section__breadcrumb\n        font-weight 600\n        margin-bottom 10px\n        @media (max-width: $mobile)\n            font-size .85em\n            margin-bottom 5px\n        a\n            display inline-block\n            border-bottom 2px solid black\n            &:first-child\n                @media (max-width: $mobile)\n                    display block\n                    border-bottom 0\n        .fa\n            margin 0 5px 2px\n            font-size .7em\n            @media (max-width: $mobile)\n                margin-left 0\n        //&.--sutil\n        span\n            opacity .4\n        a\n            opacity .4\n            border-color transparent\n            &:hover\n                opacity 1\n                border-color black\n        @media (max-width: $mobile)\n            margin-top -5px\n            a:first-child\n            span\n                display none\n\n\n    &.section--white\n        background white\n        padding 30px\n        @media (min-width: $mobile)\n            padding 30px\n        @media (min-width: $tablet)\n            padding 40px\n\n\n\n    &.section--main\n        margin-bottom 30px\n        position relative\n        @media (max-width: $mobile)\n            margin 0 -10px\n\n        .section__intro\n            margin-bottom 20px\n            @media (min-width: $tablet)\n                margin-bottom 30px\n                display grid\n                grid-gap 40px\n                grid-template-columns 1fr 1fr\n\n            .section__header\n                @media (max-width: $tablet)\n                    margin-bottom 20px\n\n                .section__title\n                    position relative\n                    @media (min-width: $tablet)\n                        font-size 5vw\n                    @media (max-width: $tablet)\n                        margin-bottom 15px\n\n                .section__excerpt\n                    font-size 1.1em\n                    margin-bottom 0\n                    //@media (min-width: $tablet)\n                    //    font-size 1.6em\n                    @media (min-width: $desktop)\n                        font-size 1.75vw\n                    p\n                        margin 0\n\n\n            .section__3d\n                height 200px\n                margin 0 -30px 20px\n                margin 0 0 20px\n                border 2px solid black\n                position relative\n                @media (min-width: $tablet)\n                    width 100%\n                    padding-bottom 90%\n                    height 0\n                    margin 0\n                    //height 360px\n                    /*\n                    position absolute\n                    width 400px\n                    top 30px\n                    right 30px\n                    */\n                /*\n                @media (min-width: $desktop)\n                    top 40px\n                    right 40px\n                */\n                canvas\n                    display block\n                    position absolute\n                    top 0\n                    left 0\n                    width 100% !important\n                    height 100% !important\n                    cursor move\n\n        .section__content\n            position relative\n            column-gap 40px\n            p:first-child\n                font-size 140%\n            @media (min-width: $tablet)\n                column-count 2\n            //@media (min-width: $desktop)\n            //    column-count 4\n        \n\n        .section__articles\n            margin-top 30px\n\n\n    &.section--category\n        @media (max-width: $mobile)\n            margin 0 -10px\n\n        .section__category__content\n            @media (min-width: $tablet)\n                column-count 2\n                column-gap 20px\n            @media (min-width: $desktop-lg)\n                column-count 3\n                column-gap 30px\n            margin-bottom 30px\n\n            p\n                margin-bottom: 8px\n                &:last-child\n                    marign-bottom 0\n                &:first-child\n                    font-size 1.25em\n\n            @media (min-width: $tablet)\n                //font-size .95em\n                p:first-child\n                    font-size 1.4em\n\n\n\n    &.section--search\n\n        .section__search\n            margin-bottom 30px\n            padding 20px 30px\n            background white\n\n\n    //&.section--catalog\n    //    background transparent\n    //    padding 0\n\n    //&.section--categories\n    //    padding-left 0\n    //    padding-right 0\n\n\n\n\n\n    // -----------------------------\n    // Instrument ------------------\n    // -----------------------------\n\n\n    &.section--instrument\n        @media (max-width: $mobile)\n            margin 0 -20px\n            padding 25px\n\n\n        .section__details\n            display flex\n            flex-wrap wrap\n            gap 30px\n            margin 10px 0 30px\n            @media (max-width: $tablet)\n                gap 20px\n            @media (max-width: $mobile)\n                gap 15px\n\n            .section__detail\n                border-top 1px solid black\n                padding-top 20px\n                margin 0\n                flex 1\n                box-sizing border-box\n                min-width 300px\n                @media (max-width: $mobile)\n                    padding-top 15px\n                @media (min-width: $tablet)\n                    min-width 320px\n                strong\n                    display block\n                    opacity .4\n                    font-weight normal\n                    line-height 1\n                    margin-bottom 4px\n                    //@media (max-width: $mobile)\n                    font-size .9em\n                .large-text\n                    display block\n                    font-weight: normal\n                    color: #333\n                    font-size: 1.1em\n                    @media (min-width: $mobile)\n                        font-size: 1.2em\n                    //    font-size: 1.3em\n\n\n                &.section__detail--dimensions\n                    display flex\n                    gap 20px\n                    p\n                        margin 0\n\n\n        .section__swiper\n            margin 0 -25px\n            @media (min-width: $mobile)\n                margin 0 -30px\n            @media (min-width: $tablet)\n                margin 0\n\n        .section__3d\n            background #E9E9E9\n            margin 0 -25px\n            @media (min-width: $mobile)\n                margin 0\n            .section__header\n                padding 30px 30px 0\n            .section__title\n                margin 0\n            p\n                margin 0\n\n\n        .section__canvas\n            position relative\n            padding-bottom 100%\n            height 400px\n            @media (min-width: $desktop)\n                height auto\n                padding-bottom (6*100/9)%\n            cursor grab\n            canvas\n                position absolute\n                top 0\n                left 0\n                width 100% !important\n                height 100% !important\n                background-color #E9E9E9 // Color de fondo temporal\n            \n            .section__canvas__tools\n                position: absolute\n                bottom: 20px\n                left: 0px\n                width: 100%\n                text-align center\n                .section__canvas__zoom\n                    @media (max-width: $tablet)\n                        input\n                            width 140px\n\n            label\n                padding 5px\n                display inline-block\n                input\n                    vertical-align middle\n                input[type='range']\n                    width 260px\n\n            &.section__canvas-B\n                position relative\n                padding-bottom (8*100/16)%\n\n\n\n        .section__ar\n            background-color #E9E9E9\n            padding 30px\n            @media (min-width: $desktop)\n                display none\n\n\n\n        .section__info\n            position relative\n            padding 30px         \n            background-color #E9E9E9\n\n            h2,h3,h4\n                margin-top 0\n            h3\n                font-size 1.2em\n\n            a\n                text-decoration underline\n                word-wrap break-word\n                word-break: break-all\n                overflow hidden\n                text-overflow ellipsis\n                inline-size 150px\n\n            &.section__info--lg\n                @media (min-width: $tablet)\n                    padding: 50px\n\n            .large-textXXX\n                @media (min-width: $tablet)\n                    font-size 1.2em\n\n\n\n        .section__microtomografia\n            h2\n                margin-bottom 0\n\n\n\n","\n\n// -----------------------------\n// ARTICLES --------------------\n// -----------------------------\n\narticle.article--category\n    background white\n    padding 50px 0\n    overflow hidden\n    //margin-bottom 30px\n    position relative\n    border-top 2px solid black\n    @media (min-width: $desktop)\n        padding 40px 0\n\n    /*@media (min-width: $tablet)\n        display grid\n        grid-gap 30px\n        grid-template-columns 460px 1fr\n    */\n\n\n    .article__title\n        margin-bottom 15px\n        font-size 240%\n\n    .article__description\n        max-width 600px\n\n    .article__btnXX\n        @media (min-width: $tablet)\n            position absolute\n            bottom 40px\n            right 40px\n\n    .article__images\n        margin 20px 0\n        //@media (max-width: $tablet)\n        //    margin-bottom 25px\n        .gggg\n            display flex\n            flex-wrap wrap\n            margin -2px\n            .flex__33\n                width 33%\n                padding 2px\n\n\n\narticle.article--instrument\n    position: relative\n    background:  #FF000\n    cursor: pointer\n    border 1px solid black\n\n    .article__image\n        position relative\n\n    .article__body\n        padding: 20px\n        border-top 1px solid black\n        transition .25s ease\n\n    .article__num\n        padding-top 5px\n        margin 0\n        opacity .4\n\n    .article__link\n        position absolute\n        bottom 0\n        right 0\n        margin 0\n        padding 20px\n        color black\n        letter-spacing 1px\n        text-transform uppercase\n        font-size .8em\n        font-weight bold\n        opacity .4\n        transition .2s ease\n    &:hover\n        .article__link\n            opacity 1\n\n    .article__title\n        margin 0\n        padding 0\n        font-size 1.2em\n        line-height 1.2\n        a\n            color black\n            text-decoration none\n            &::after\n                display block\n                content \"\"\n                position absolute\n                top 0\n                left 0\n                width 100%\n                height 100%\n            span\n                font-weight normal\n \n\n    .article__canvas\n        position: absolute\n        top: 0\n        left: 0\n        width: 100%\n        height: 100%\n        display: none                // Oculto por defecto\n        justify-content: center\n        align-items: center\n        animation fadeIn .25s .25s ease backwards\n        canvas\n            display block\n            width: 100% !important\n            height: 100% !important\n\n\n    &:hover .article__canvas\n        display block\n","\n// -----------------------------\n// Swiper ------------------\n// -----------------------------\n\n\n\n\n.swiper.swiper--main\n    position relative\n    user-select none\n    overflow hidden\n\n.swiper-thumbnails\n    display flex\n    gap 5px\n    margin 5px 0 0\n\n    .swiper-thumbnail\n        cursor pointer\n        opacity .6\n        transition .2s ease\n        position relative\n        &.--current\n            opacity 1\n            z-index 2\n            &::after\n                content \"\"\n                display block\n                position absolute\n                top 0\n                left 0\n                width 100%\n                height 100%\n                border 2px solid black\n                box-sizing border-box\n        &:hover\n            opacity 1\n    \n    &.swiper-thumbnails--B\n        display flex\n        //gap 5px\n        gap 0\n        //margin -5px\n        margin 0\n        flex-wrap wrap\n\n        .swiper-thumbnail\n            //padding 5px\n            width 33.33%\n            box-sizing border-box\n                    \n\n.swiper-button-next, .swiper-button-prev\n    color black !important\n    opacity .2\n    transition .2s ease\n    &:hover\n        opacity 1\n\n\n.swiper-pagination-bullet.swiper-pagination-bullet-active\n    background black\n","\n@keyframes animPulse\n    0%\n        transform scale(1)\n    50%\n        transform scale(1.05)\n\n\n\n// MIC VIEW\n\n.micView\n    position fixed\n    top 0\n    left 0\n    width 100%\n    height 100%\n    background rgba(0,0,0,.25)\n    //backdrop-filter: blur(10px);\n    z-index 20\n    display none\n    animation fadeIn .5s ease\n    text-align center\n\n    .micView__container\n        position absolute\n        top 0\n        left 0\n        width 100%\n        height 100%\n        background white\n        padding 30px\n        box-sizing border-box\n        overflow auto\n        @media (min-width: $tablet)\n            transform translate(0,-50%)\n            max-width 400px\n            margin-left -200px\n            top 50%\n            left 50%\n            height auto\n    \n    .micView__close\n        position absolute\n        top 0\n        right 0\n        padding 20px\n        cursor pointer\n        opacity .25\n        transition .2s ease\n        &:hover\n            opacity 1\n\n\n    .micView__bigButton\n        background white\n        color black\n        border 2px solid black\n        cursor pointer\n        width 120px\n        height 120px\n        border-radius 120px\n        padding 0\n        margin 0\n        text-transform uppercase\n        transition .2s ease\n        font-weight bold\n        position relative\n        tap 0\n        &::after\n            content \"\"\n            display block\n            width 120%\n            height 120%\n            position absolute\n            top -10%\n            left -10%\n            box-sizing border-box\n            border 2px solid black\n            border-radius 120px\n            animation animPulse .5s ease infinite\n            opacity 0\n            transition .2s ease\n        &.active\n            &::after\n                opacity 1\n        &:active\n            transform scale(0.95)\n        &:hover\n            background black\n            color white\n\n    .micView__text\n        margin 20px 0\n\n    .micView__level\n        margin: 20px 0;\n        border: 2px solid black;\n        padding: 20px;\n        border-radius: 30px;\n\n        .micView__level__icon\n            width 20px\n            float left\n            margin-top: -8px;\n            margin-left: -5px;\n\n        .micView__level__bar\n            margin-left: 30px;\n            background: black;\n            height: 3px;\n            border-radius: 4px;\n            transition: .05s;\n\n    .micView__gain\n        margin: 20px 0;\n\n    .micView__fall\n        padding 20px\n        background #EEE\n        padding-top 20px\n        margin-top 20px\n        font-size .95em\n        h4\n            margin-bottom 0\n        p\n            margin-bottom 5px\n        .micView__fall__toggle\n            cursor pointer\n        .micView__fall__options\n            display none\n\n@keyframes animOsc\n    0% \n        transform rotate(0deg) \n    25% \n        transform rotate(8deg) \n    50% \n        transform rotate(0deg) \n    75%\n        transform rotate(-8deg) \n    100% \n        transform rotate(0deg) \n\n#micView__anim\n    display block\n    max-width 240px\n    margin 20px auto\n\n    .bar\n        fill: none;\n        stroke: #231f20;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n        opacity .1\n        transform-origin 50% 90%\n        transition .1s ease all\n        &.active\n            animation animOsc .15s linear infinite\n            /*\n            &:nth-child(1)\n                animation-delay .01s\n            &:nth-child(2)\n                animation-delay .021s\n            &:nth-child(4)\n                animation-delay .032s\n            &:nth-child(4)\n                animation-delay .043s\n            &:nth-child(5)\n                animation-delay .055s\n            &:nth-child(6)\n                animation-delay .07s\n            &:nth-child(7)\n                animation-delay .09s\n            &:nth-child(8)\n                animation-delay .11s\n            &:nth-child(9)\n                animation-delay .15s\n            &:nth-child(10)\n                animation-delay .2s\n            */\n\n\n\n\n\n\n\n\n\n\n// Wave view\n\n.wave {\n    display: block;\n    //margin: 20px 0;\n    position: absolute;\n    top: 30px;\n    right: 30px;\n    @media (min-width: $tablet) {\n        top: 50px;\n        right: 40px;\n    }\n\n    .wave-bars {\n        height: 60px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        align-items: center;\n        div {\n            min-height: 3px;\n            width: 3px;\n            margin: 0 2px;\n            background-color: black;\n            transition: height .05s linear;\n            border-radius: 3px;\n        }\n        @media (max-width: $tablet) {\n            div:nth-child(15),\n            div:nth-child(16),\n            div:nth-child(17),\n            div:nth-child(18),\n            div:nth-child(19),\n            div:nth-child(20) {\n                display: none;\n            }\n        }\n\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
